import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Button,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { Business } from "lib/features/business/types";
import { useEffect, useState } from "react";
import { createBusinessListStyles } from "styles/BusinessListDirectory/createBusinessList.styles";
import AllCategories from "../AllCategories";
import BusinesslistCard from "./BusinesslistCard";

interface AddBusinessesListProps {
  handleBusinessRecords: (business: Business, action: boolean) => void;
  selectedBusinesses: Business[];
  setShowBusinesses: React.Dispatch<React.SetStateAction<boolean>>;
  businessList: Business[];
  filteredBusiness: Business[];
  setFilteredBusiness: React.Dispatch<React.SetStateAction<Business[]>>;
}

const AddBusinessesList = ({
  handleBusinessRecords,
  selectedBusinesses,
  setShowBusinesses,
  businessList,
  filteredBusiness,
  setFilteredBusiness,
}: AddBusinessesListProps) => {
  const [searchValue, setSearchValue] = useState<string>("");
  const [activeCategoryIndex, setActiveCategoryIndex] = useState(0);

  const [selectedCategory, setSelectedCategory] = useState<{
    id: number;
    name: string;
  }>({ id: 2, name: "All" });

  const handleActiveCategory = (id: number, name: string, index: number) => {
    if (index != activeCategoryIndex) {
      setActiveCategoryIndex(index);
      setSelectedCategory({ id, name });
    }
  };

  const handleSearchQuery = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const text = e.target.value;
    setSearchValue(text);

    if (text.length > 0) {
      const results = businessList.filter((business) =>
        business.business.toLowerCase().includes(text.toLowerCase())
      );
      setFilteredBusiness(results);
    } else {
      setFilteredBusiness(businessList);
    }
  };

  useEffect(() => {
    if (!businessList) return;

    let filteredBusinesses = businessList;

    if (selectedCategory.name === "Favorites") {
      filteredBusinesses = businessList.filter(
        (business) => business.isFavorite
      );
    } else {
      filteredBusinesses = businessList.filter(
        (business) =>
          selectedCategory.name === "All" ||
          business.categories.some(
            (category) => category.category === selectedCategory.name
          )
      );
    }

    setFilteredBusiness(filteredBusinesses);
  }, [selectedCategory, businessList]);

  return (
    <Box marginTop={1}>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box sx={[createBusinessListStyles.searchContainer]}>
          <TextField
            variant="outlined"
            placeholder="Search"
            fullWidth
            value={searchValue}
            onChange={handleSearchQuery}
            sx={createBusinessListStyles.searchInput}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: "gray" }} />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Button
          variant="contained"
          sx={createBusinessListStyles.addBtn}
          disabled={selectedBusinesses?.length === 0}
          onClick={() => setShowBusinesses(false)}
        >
          Add {selectedBusinesses?.length} to List
        </Button>
      </Box>

      {/* Categories */}
      <AllCategories
        handleActiveCategory={handleActiveCategory}
        activeCategoryIndex={activeCategoryIndex}
        categoryType={[0, 1, 3]}
      />

      {/* Business Lists */}
      <Grid container spacing={2}>
        {filteredBusiness?.length === 0 ? (
          <Typography>No Business Found</Typography>
        ) : (
          filteredBusiness?.map((business: Business, index: number) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={business.id}>
              <BusinesslistCard
                business={business}
                handleBusinessRecords={handleBusinessRecords}
                selectedBusinesses={selectedBusinesses}
              />
            </Grid>
          ))
        )}
      </Grid>
    </Box>
  );
};

export default AddBusinessesList;
